import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const New = ({ color, size, title, titleId, aphroditeStyles = [] }: Props) => (
  <Icon
    color="none"
    size={size}
    aphroditeStyles={aphroditeStyles}
    title={title}
    titleId={titleId}
    viewBoxWidth={20}
    viewBoxHeight={20}
  >
    <mask
      id="mask0_1366_22169"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="3"
      width="20"
      height="14"
    >
      <mask
        id="mask1_1366_22169"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_1366_22169)">
        <path
          d="M2.50065 16.6663C2.04232 16.6663 1.64996 16.5031 1.32357 16.1768C0.997179 15.8504 0.833984 15.458 0.833984 14.9997V4.99967C0.833984 4.54134 0.997179 4.14898 1.32357 3.82259C1.64996 3.4962 2.04232 3.33301 2.50065 3.33301H17.5006C17.959 3.33301 18.3513 3.4962 18.6777 3.82259C19.0041 4.14898 19.1673 4.54134 19.1673 4.99967V14.9997C19.1673 15.458 19.0041 15.8504 18.6777 16.1768C18.3513 16.5031 17.959 16.6663 17.5006 16.6663H2.50065ZM3.95898 9.58301L5.93815 12.2913C5.97982 12.3608 6.03537 12.4129 6.10482 12.4476C6.17426 12.4823 6.25065 12.4997 6.33398 12.4997H6.58398C6.72287 12.4997 6.84093 12.4511 6.93815 12.3538C7.03537 12.2566 7.08398 12.1386 7.08398 11.9997V8.02051C7.08398 7.86773 7.03537 7.74273 6.93815 7.64551C6.84093 7.54829 6.71593 7.49967 6.56315 7.49967C6.41037 7.49967 6.28537 7.54829 6.18815 7.64551C6.09093 7.74273 6.04232 7.86773 6.04232 8.02051V10.4163L4.10482 7.70801C4.04926 7.63856 3.98676 7.58648 3.91732 7.55176C3.84787 7.51704 3.77148 7.49967 3.68815 7.49967H3.43815C3.28537 7.49967 3.16037 7.54829 3.06315 7.64551C2.96593 7.74273 2.91732 7.86773 2.91732 8.02051V11.9788C2.91732 12.1316 2.96593 12.2566 3.06315 12.3538C3.16037 12.4511 3.28537 12.4997 3.43815 12.4997C3.59093 12.4997 3.71593 12.4511 3.81315 12.3538C3.91037 12.2566 3.95898 12.1316 3.95898 11.9788V9.58301ZM8.33398 12.4997H10.7298C10.8826 12.4997 11.0076 12.4511 11.1048 12.3538C11.202 12.2566 11.2507 12.1316 11.2507 11.9788C11.2507 11.8261 11.202 11.7011 11.1048 11.6038C11.0076 11.5066 10.8826 11.458 10.7298 11.458H9.16732V10.5413H10.7298C10.8826 10.5413 11.0076 10.4927 11.1048 10.3955C11.202 10.2983 11.2507 10.1733 11.2507 10.0205C11.2507 9.86773 11.202 9.74273 11.1048 9.64551C11.0076 9.54829 10.8826 9.49967 10.7298 9.49967H9.16732V8.54134H10.7298C10.8826 8.54134 11.0076 8.49273 11.1048 8.39551C11.202 8.29829 11.2507 8.17329 11.2507 8.02051C11.2507 7.86773 11.202 7.74273 11.1048 7.64551C11.0076 7.54829 10.8826 7.49967 10.7298 7.49967H8.33398C8.22287 7.49967 8.12565 7.54134 8.04232 7.62467C7.95898 7.70801 7.91732 7.80523 7.91732 7.91634V12.083C7.91732 12.1941 7.95898 12.2913 8.04232 12.3747C8.12565 12.458 8.22287 12.4997 8.33398 12.4997ZM12.9173 12.4997H16.2506C16.4868 12.4997 16.6847 12.4198 16.8444 12.2601C17.0041 12.1004 17.084 11.9025 17.084 11.6663V8.02051C17.084 7.86773 17.0354 7.74273 16.9382 7.64551C16.8409 7.54829 16.7159 7.49967 16.5631 7.49967C16.4104 7.49967 16.2854 7.54829 16.1882 7.64551C16.0909 7.74273 16.0423 7.86773 16.0423 8.02051V11.2497H15.1256V8.85384C15.1256 8.70106 15.077 8.57606 14.9798 8.47884C14.8826 8.38162 14.7576 8.33301 14.6048 8.33301C14.452 8.33301 14.327 8.38162 14.2298 8.47884C14.1326 8.57606 14.084 8.70106 14.084 8.85384V11.2497H13.1256V8.02051C13.1256 7.86773 13.077 7.74273 12.9798 7.64551C12.8826 7.54829 12.7576 7.49967 12.6048 7.49967C12.452 7.49967 12.327 7.54829 12.2298 7.64551C12.1326 7.74273 12.084 7.86773 12.084 8.02051V11.6663C12.084 11.9025 12.1638 12.1004 12.3236 12.2601C12.4833 12.4198 12.6812 12.4997 12.9173 12.4997Z"
          fill="#1C1B1F"
        />
      </g>
    </mask>
    <g mask="url(#mask0_1366_22169)">
      <rect width="20" height="20" fill={color} />
    </g>
  </Icon>
);
New.displayName = 'New';

export default New;
